
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[org]",
      function () {
        return require("private-next-pages/[org]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[org]"])
      });
    }
  